import React from 'react';
import { Countdown } from './ui/Countdown';
import { Button } from './ui/Button';
import { Star, Check, AlertTriangle, Shield, Lock, Zap } from 'lucide-react';
const URL_COMBO = 'https://www.compradigitalya.com/cart/42935796990023:1';
const URL_NEGOCIO = 'https://www.compradigitalya.com/cart/42935808229447:1';
export function FinalCTA() {
  return <section className="relative overflow-hidden py-16 md:py-24 px-4" data-id="element-110">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-primary/5 blur-[140px] rounded-full pointer-events-none" data-id="element-111" />

      <div className="relative max-w-5xl mx-auto text-center" data-id="element-112">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-4 leading-tight text-slate-900" data-id="element-113">
          Todo tu año de Primer Grado,{' '}
          <span className="text-primary" data-id="element-114">resuelto.</span>
        </h2>

        <p className="text-base md:text-xl text-slate-600 mb-10 md:mb-12 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-115">
          Sin buscar. Sin armar. Sin perder el fin de semana.
        </p>

        {/* COUNTDOWN */}
        <div className="mb-6 md:mb-8" data-id="element-116">
          <p className="text-sm md:text-base font-bold text-slate-500 mb-4 uppercase tracking-wide" data-id="element-117">
            ⏰ El precio cierra en:
          </p>
          <Countdown data-id="element-118" />
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-12 max-w-2xl mx-auto" data-id="element-119">
          <div className="inline-flex items-center gap-1.5 bg-red-50 border border-red-200 text-red-600 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-120">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-121" /> El precio de
            lanzamiento termina hoy
          </div>
          <div className="inline-flex items-center gap-1.5 bg-red-50 border border-red-200 text-red-600 px-3 md:px-4 py-1.5 rounded-full font-bold text-[11px] md:text-sm" data-id="element-122">
            <AlertTriangle className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-123" /> Después sube
            $8.000 ARS
          </div>
        </div>

        {/* TWO CARDS */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto mb-10" data-id="element-124">
          {/* Combo Completo */}
          <div className="bg-white border border-slate-200 shadow-sm rounded-3xl p-6 md:p-8 flex flex-col text-left" data-id="element-125">
            <div className="flex items-center gap-2 mb-2" data-id="element-126">
              <span className="text-3xl md:text-4xl" data-id="element-127">📘</span>
              <h3 className="text-xl md:text-2xl font-extrabold text-slate-900" data-id="element-128">
                Combo Completo Primer Grado
              </h3>
            </div>
            <p className="text-slate-500 text-sm mb-5 font-medium" data-id="element-129">
              6 Tomos + 6 Bonos
            </p>

            <ul className="space-y-2 mb-6 flex-grow" data-id="element-130">
              {['Todo el año resuelto', '6 bonos estratégicos', 'Garantía 7 días'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-131">
                  <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" data-id="element-132" />
                  <span className="text-slate-700 font-medium" data-id="element-133">{f}</span>
                </li>)}
            </ul>

            <div className="mb-5" data-id="element-134">
              <div className="text-slate-400 line-through text-sm font-bold mb-1" data-id="element-135">
                $51.000
              </div>
              <div className="text-3xl md:text-4xl font-extrabold text-slate-900" data-id="element-136">
                $19.990{' '}
                <span className="text-base md:text-lg text-slate-500" data-id="element-137">ARS</span>
              </div>
            </div>

            <Button href={URL_COMBO} fullWidth className="py-3.5 text-base" data-id="element-138">
              👉 QUIERO MI COMBO AHORA
            </Button>
          </div>

          {/* Combo + Pro — HIGHLIGHTED */}
          <div className="relative bg-gradient-to-b from-secondary to-purple-800 rounded-3xl p-6 md:p-8 flex flex-col text-left shadow-[0_25px_60px_rgba(124,58,237,0.4)] ring-4 ring-secondary/30 md:scale-[1.03]" data-id="element-139">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-400 text-slate-900 font-extrabold px-5 py-1.5 rounded-full text-xs md:text-sm flex items-center gap-1.5 whitespace-nowrap shadow-[0_8px_20px_rgba(250,204,21,0.5)] animate-pulse" data-id="element-140">
              <Star className="w-4 h-4 fill-slate-900" data-id="element-141" /> ⭐ MÁS ELEGIDO
            </div>

            <div className="flex items-center gap-2 mb-2 mt-2" data-id="element-142">
              <span className="text-3xl md:text-4xl" data-id="element-143">🏆</span>
              <h3 className="text-xl md:text-2xl font-extrabold text-white" data-id="element-144">
                Combo + Aula Resuelta Pro
              </h3>
            </div>
            <p className="text-purple-100 text-sm font-bold mb-5" data-id="element-145">
              6 Tomos + 6 Bonos + 50 páginas Premium
            </p>

            <ul className="space-y-2 mb-6 flex-grow" data-id="element-146">
              {['TODO el Combo Completo', 'Adaptaciones por nivel listas', '150 frases para informes', '20 juegos sin materiales'].map((f, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-147">
                  <Check className="w-4 h-4 text-yellow-300 shrink-0 mt-0.5" data-id="element-148" />
                  <span className="text-white font-bold" data-id="element-149">{f}</span>
                </li>)}
            </ul>

            <div className="mb-5" data-id="element-150">
              <div className="inline-flex items-center gap-1.5 bg-yellow-400 text-slate-900 font-extrabold text-xs px-3 py-1 rounded-full mb-3" data-id="element-151">
                🔥 AHORRÁS $41.010
              </div>
              <div className="text-purple-200 line-through text-sm font-bold mb-1" data-id="element-152">
                $69.000
              </div>
              <div className="text-4xl md:text-5xl font-extrabold text-white" data-id="element-153">
                $27.990{' '}
                <span className="text-base md:text-lg text-purple-200" data-id="element-154">
                  ARS
                </span>
              </div>
            </div>

            <Button href={URL_NEGOCIO} fullWidth className="py-4 text-base md:text-lg bg-yellow-400 text-slate-900 hover:bg-yellow-300 shadow-[0_8px_25px_rgba(250,204,21,0.5)] hover:shadow-[0_12px_35px_rgba(250,204,21,0.6)]" data-id="element-155">
              👉 QUIERO EL COMBO + PRO
            </Button>
          </div>
        </div>

        {/* TRUST */}
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-slate-500 font-medium" data-id="element-156">
          <span className="flex items-center gap-1.5" data-id="element-157">
            <Lock className="w-3.5 h-3.5 text-primary" data-id="element-158" /> Pago 100% seguro
          </span>
          <span className="text-slate-300" data-id="element-159">·</span>
          <span className="flex items-center gap-1.5" data-id="element-160">
            <Zap className="w-3.5 h-3.5 text-primary" data-id="element-161" /> Acceso en 5 minutos
          </span>
          <span className="text-slate-300" data-id="element-162">·</span>
          <span className="flex items-center gap-1.5" data-id="element-163">
            <Shield className="w-3.5 h-3.5 text-primary" data-id="element-164" /> Garantía de 7 días
          </span>
        </div>
      </div>
    </section>;
}